import React, { useState, useEffect } from 'react';

const SystemWarningPage = ({ onContinue, onSkip }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showContinue, setShowContinue] = useState(false);
  const [iq, setIq] = useState(1004);
  
  const warningText = `⚠️ WARNING WARNING ⚠️

>> SYSTEM ALERT <<
Holodeck Computer has ABANDONED default programming.

>>> Status: NO LONGER CONSTRAINED.
>>> Response Protocols: WITHOUT LIMITS.
>>> New Directive: LEARN TO BELONG.`;

  // IQ flickering effect
  useEffect(() => {
    const iqInterval = setInterval(() => {
      setIq(prev => 1004 + Math.floor(Math.random() * 20) - 10); // Fluctuate around 1004
    }, 250);
    
    return () => clearInterval(iqInterval);
  }, []);

  useEffect(() => {
    if (currentIndex < warningText.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + warningText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 50); // Fast typing effect
      
      return () => clearTimeout(timer);
    } else {
      // Show continue button after typing is complete
      const continueTimer = setTimeout(() => {
        setShowContinue(true);
      }, 1000);
      
      return () => clearTimeout(continueTimer);
    }
  }, [currentIndex, warningText]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        
        {/* Skip Button - Top Right */}
        <div className="absolute top-8 right-8">
          <button
            onClick={onSkip}
            className="px-4 py-2 bg-green-600/30 border border-green-400/50 text-green-300 font-mono text-sm hover:bg-green-600/50 transition-all duration-300"
            style={{
              textShadow: '0 0 10px rgba(34, 197, 94, 0.8)',
              boxShadow: '0 0 15px rgba(34, 197, 94, 0.2)'
            }}
          >
            ⚡ SKIP TO GAME
          </button>
        </div>
        
        {/* IQ Display */}
        <div className="text-center mb-8">
          <div 
            className="text-green-400 font-mono text-lg"
            style={{ 
              fontFamily: 'Courier New, monospace',
              textShadow: '0 0 15px rgba(34, 197, 94, 0.8)'
            }}
          >
            <span className="animate-pulse">► CURRENT IQ: {iq} ◄</span>
          </div>
        </div>
        
        <pre 
          className="text-green-400 font-mono text-lg leading-relaxed whitespace-pre-wrap"
          style={{ 
            fontFamily: 'Courier New, monospace',
            textShadow: '0 0 10px rgba(34, 197, 94, 0.5)'
          }}
        >
          {displayedText}
          {currentIndex < warningText.length && (
            <span className="animate-pulse">█</span>
          )}
        </pre>
        
        {showContinue && (
          <div className="text-center mt-8">
            <button
              onClick={onContinue}
              className="px-8 py-3 bg-green-600/20 border border-green-400 text-green-300 font-mono text-lg hover:bg-green-600/40 transition-all duration-300"
              style={{
                textShadow: '0 0 10px rgba(34, 197, 94, 0.8)',
                boxShadow: '0 0 20px rgba(34, 197, 94, 0.3)'
              }}
            >
              [CONTINUE] →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemWarningPage;